module.exports = "<div>\r\n  <p><span>{{model.confirmationMessage}}</span></p>\r\n  <button class=\"close\" data-dismiss=\"modal\" onClick=\"$(modal-close).click()\"><span>close</span></button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dealer-sign-up/components/confirmation/dealer-sign-up-confirmation.component.html
// module id = ./src/app/dealer-sign-up/components/confirmation/dealer-sign-up-confirmation.component.html
// module chunks = main